import * as React from "react";

import { Button } from "jazasoft";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Table from "../../components/Table";
import { useDeepMemo } from "../../hooks";
import { isEmpty, toFixed, toFixedValue } from "../../utils/helpers";
import { cbLayRowSort } from "../../helpers/orderHelper";

const columns = [
  { dataKey: "serialNo", title: "Sl. No." },
  { dataKey: "rollNo", title: "F. Roll No." },
  { dataKey: "supplierRollNo", title: "S. Roll No." },
  { dataKey: "style", title: "Style" },
  { dataKey: "color", title: "Color" },
  { dataKey: "rollWeight", title: "Weight" },
  { dataKey: "rollLength", title: "Length" },
  { dataKey: "width", title: "Width" },
  { dataKey: "shade", title: "Shade" },
  { dataKey: "plannedPly", title: "Plies" },
  { dataKey: "plannedBalance", title: "Balance" },
  { dataKey: "next", title: "Next" }
];

const LayDialog = props => {
  const { open, orderFlow, rollFields = [], lay, onClose } = props;

  const rows = useDeepMemo(() => {
    if (isEmpty(orderFlow) || isEmpty(lay)) return [];
    const { marker, rowList } = lay;

    let rows = rowList.sort(cbLayRowSort).map(row => ({
      ...row,
      plannedBalance: `${row.plannedBalance}`,
      rollNo: `${row.rollNo}`,
      width: `${row.width} cm`,
      layLength: marker.layLength,
      rollLength: `${toFixedValue(row.currLength)} m (${toFixedValue(row.length)} m)`,
      rollWeight: !isEmpty(row.currWeight) && !isEmpty(row.weight) ? `${toFixedValue(row.currWeight, 3)} kg (${toFixedValue(row.weight, 3)} kg)` : "",
      next: row.next || "-"
    }));

    const keys = ["currLength", "currWeight", "plannedPly"];
    const totalRow = keys.reduce(
      (acc, key) => ({
        ...acc,
        [key]: toFixed(
          rows.reduce((acc, row) => acc + parseFloat(row[key] || 0), 0),
          0
        )
      }),
      {}
    );
    rows.push({
      ...totalRow,
      rollLength: `${toFixed(totalRow.currLength, 1)} m`,
      rollWeight: totalRow.currWeight > 0 ? `${toFixed(totalRow.currWeight, 1)} kg` : "",
      rollNo: "Total"
    });

    return rows;
  }, [orderFlow, lay]);

  const finalColumns = useDeepMemo(() => {
    let cols = [...columns];
    if (!rollFields.includes("supplierRollNo")) {
      cols = cols.filter(h => h.dataKey !== "supplierRollNo");
    }
    if (rows.every(e => !isEmpty(e.rollWeight))) {
      cols = cols.filter(h => h.dataKey !== "rollWeight");
    }
    return cols;
  }, [columns, rollFields, rows]);

  return (
    <Dialog id="dialog-container" fullWidth={true} maxWidth="xl" open={open} onClose={onClose}>
      <DialogTitle id="dialog-title">Lay #{lay && lay.layNo}</DialogTitle>
      <DialogContent id="dialog-content">
        <div>
          <Table columns={finalColumns} rows={rows} cellStyle={({ record }) => (record.rollNo === "Total" ? { fontWeight: "bold" } : {})} />
        </div>
      </DialogContent>
      <DialogActions id="dialog-actions" style={{ padding: "1em" }}>
        <Button label="Close" variant="outlined" onClick={onClose} color="primary" />
      </DialogActions>
    </Dialog>
  );
};

export default LayDialog;
